var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('span',{staticClass:"visualizer-item mr-4"},[_c('color-visualizer',{attrs:{"value":_vm.value.color}})],1),_c('span',{staticClass:"visualizer-item width-element mr-4"},[_vm._v(" "+_vm._s(_vm.value.width)+"px ")])])}
var staticRenderFns = []

export { render, staticRenderFns }